export const toggleBackButtonAction = (data) => {
  return {
    type: 'TOGGLE_BACK',
    payload: data
  };
};
